import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsBackupRestoreIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_backup_restore"}/>
}
